module.exports = new __parcel__URL__("intro-to-ghg-center--cover.ec6b150b.png").toString();